document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('qw-grid');
  if (!container) return;
  const endpoint = container.dataset.endpoint;
  if (!endpoint) return;

  const searchInput = document.getElementById('qw-search');
  const searchClear = document.getElementById('qw-search-clear');
  const sortSelect = document.getElementById('qw-sort');
  const countNum = document.getElementById('qw-count-num');
  
  let allQuestions = [];
  let filteredQuestions = [];
  let currentIndex = 0;
  const BATCH_SIZE = 12;

  const stickyColors = ['#FFE772', '#4AC1E0', '#FF5223', '#FF5892', '#FFFFFF', '#D3B7FF', '#C1F033'];
  
  let uniqueCategories = [];
  let activeCategory = 'All';
  let categoryPillsContainer = null;

  function updateSearchClear() {
    if (!searchClear) return;
    const val = searchInput ? searchInput.value.trim() : '';
    if (val.length > 0) {
      searchClear.classList.add('qw-show');
      searchClear.style.setProperty('display', 'inline-flex', 'important');
    } else {
      searchClear.classList.remove('qw-show');
      searchClear.style.setProperty('display', 'none', 'important');
    }
  }

  // Enforce clear button hidden on startup
  updateSearchClear();

  const scrollObserver = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      renderBatch();
    }
  }, { rootMargin: '200px' });

  init();

  async function init() {
    container.innerHTML = `
      <div class="qw-skeleton-card"><div class="qw-skel-line" style="width:85%"></div><div class="qw-skel-line" style="width:60%"></div></div>
      <div class="qw-skeleton-card"><div class="qw-skel-line" style="width:90%"></div><div class="qw-skel-line" style="width:70%"></div></div>
      <div class="qw-skeleton-card"><div class="qw-skel-line" style="width:80%"></div><div class="qw-skel-line" style="width:50%"></div></div>
    `;
    
    const pageHeader = document.querySelector('.qw-page-header');
    if (pageHeader && !categoryPillsContainer) {
      categoryPillsContainer = document.createElement('div');
      categoryPillsContainer.className = 'qw-category-pills';
      pageHeader.parentNode.insertBefore(categoryPillsContainer, container);
    }

    try {
      const cached = localStorage.getItem('qw_cache');
      if (cached) {
        try {
          const parsed = JSON.parse(cached);
          if (Array.isArray(parsed)) {
            processData(parsed);
          }
        } catch(e) {
          localStorage.removeItem('qw_cache');
        }
      }
      
      const res = await fetch(endpoint);
      if (res.ok) {
        const freshData = await res.json();
        if (Array.isArray(freshData)) {
          localStorage.setItem('qw_cache', JSON.stringify(freshData));
          if (!cached || JSON.stringify(freshData) !== cached) {
            processData(freshData);
          }
        } else {
          console.error('Data from Apps Script is not an array:', freshData);
          if (!cached) container.innerHTML = '<p style="text-align:center; grid-column:1/-1;">Error: Invalid data format.</p>';
        }
      }
    } catch (err) {
      if (!allQuestions.length) {
        container.innerHTML = '<p style="text-align:center; grid-column:1/-1;">Error loading questions. Please try again later.</p>';
      }
      console.error(err);
    }
  }

  function processData(data) {
    if (!Array.isArray(data)) return;
    allQuestions = data;
    const categoriesSet = new Set();

    const COLS = 4;
    const grid2D = [];
    let currentRow = 0;
    let currentCol = 0;

    allQuestions.forEach((q, i) => {
      let cat = q['Category'] ? String(q['Category']).trim() : 'Other';
      if (!cat) cat = 'Other';
      q._category = cat;
      categoriesSet.add(cat);

      const questionText = q['Question'] || '';
      q._isWide = String(questionText).length > 90;
      const span = q._isWide ? 2 : 1;

      if (currentCol + span > COLS) {
        currentRow++;
        currentCol = 0;
      }

      if (!grid2D[currentRow]) grid2D[currentRow] = [];

      const forbiddenColors = new Set();
      
      if (currentCol > 0 && grid2D[currentRow][currentCol - 1]) {
        forbiddenColors.add(grid2D[currentRow][currentCol - 1].color);
      }
      if (currentRow > 0 && grid2D[currentRow - 1][currentCol]) {
        forbiddenColors.add(grid2D[currentRow - 1][currentCol].color);
      }
      if (currentRow > 0 && currentCol > 0 && grid2D[currentRow - 1][currentCol - 1]) {
        forbiddenColors.add(grid2D[currentRow - 1][currentCol - 1].color);
      }
      if (currentRow > 0 && currentCol + 1 < COLS && grid2D[currentRow - 1][currentCol + 1]) {
        forbiddenColors.add(grid2D[currentRow - 1][currentCol + 1].color);
      }
      if (span === 2 && currentRow > 0 && grid2D[currentRow - 1][currentCol + 1]) {
        forbiddenColors.add(grid2D[currentRow - 1][currentCol + 1].color);
      }

      let availableColors = stickyColors.filter(c => !forbiddenColors.has(c));
      if (availableColors.length === 0) {
        const leftCol = (currentCol > 0 && grid2D[currentRow][currentCol - 1]) ? grid2D[currentRow][currentCol - 1].color : null;
        const topCol = (currentRow > 0 && grid2D[currentRow - 1][currentCol]) ? grid2D[currentRow - 1][currentCol].color : null;
        availableColors = stickyColors.filter(c => c !== leftCol && c !== topCol);
      }
      if (availableColors.length === 0) availableColors = stickyColors; 
      
      q._color = availableColors[Math.floor(Math.random() * availableColors.length)];
      
      let availableTapeColors = stickyColors.filter(c => c !== q._color);
      q._tapeColor = availableTapeColors[Math.floor(Math.random() * availableTapeColors.length)];

      const rotSign = ((currentRow + currentCol) % 2 === 0) ? 'left' : 'right';
      q._rotSign = rotSign;

      q._textColor = (q._color === '#FF5223' || q._color === '#FF5892') ? '#ffffff' : '#0D1023';

      if (q._isWide) {
        q._rotation = 0; 
      } else {
        const angle = 1.8 + Math.random() * 1.8;
        q._rotation = (rotSign === 'left') ? -angle : angle;
      }

      for (let s = 0; s < span; s++) {
        grid2D[currentRow][currentCol + s] = {
          color: q._color,
          rotSign: q._rotSign
        };
      }

      currentCol += span;
    });

    uniqueCategories = Array.from(categoriesSet).filter(c => c !== 'Other').sort();
    if (categoriesSet.has('Other')) uniqueCategories.push('Other');
    uniqueCategories.unshift('All');

    renderPills();
    applyFiltersAndSort();
  }

  function renderPills() {
    if (!categoryPillsContainer) return;
    categoryPillsContainer.innerHTML = '';
    
    uniqueCategories.forEach(cat => {
      const pill = document.createElement('button');
      pill.className = `qw-pill ${cat === activeCategory ? 'active' : ''}`;
      pill.textContent = cat;
      pill.onclick = () => {
        activeCategory = cat;
        renderPills();
        applyFiltersAndSort();
      };
      categoryPillsContainer.appendChild(pill);
    });
  }

  function renderBatch() {
    if (currentIndex === 0) container.innerHTML = '';
    
    const batch = filteredQuestions.slice(currentIndex, currentIndex + BATCH_SIZE);
    
    if (batch.length === 0 && currentIndex === 0) {
      container.innerHTML = '<p style="text-align:center; padding:40px; grid-column:1/-1;">No questions found 💬</p>';
      if (countNum) countNum.textContent = '0';
      return;
    }

    if (countNum) {
      countNum.textContent = filteredQuestions.length;
    }

    batch.forEach((q, indexInBatch) => {
      const rawName = q['Name'] || 'ANON';
      const name = escapeHTML(rawName).toUpperCase();
      const age = q['Age'] ? escapeHTML(q['Age']) : '';
      const rawQuestion = q['Question'] || '';
      const question = `"${escapeHTML(rawQuestion)}"`;
      
      const card = document.createElement('div');
      card.className = `qw-card ${q._isWide ? 'qw-card-wide' : ''}`;
      card.style.backgroundColor = q._color;
      card.style.color = q._textColor;
      card.style.borderColor = '#0D1023';
      card.style.position = 'relative'; 
      card.style.opacity = '0';
      card.style.transform = 'translateY(20px) scale(0.95)';
      card.style.transition = 'opacity 0.4s ease, transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)';

      let innerColor = q._textColor;
      let isRotatedLeft = q._rotation < 0;
      let tapeLeftPos = isRotatedLeft ? 'auto' : '24px';
      let tapeRightPos = isRotatedLeft ? '24px' : 'auto';
      let tapeRotation = isRotatedLeft ? '6deg' : '-6deg';

      let tapeHTML = `
        <span aria-hidden="true" style="
          pointer-events: none; position: absolute; top: -11px; left: ${tapeLeftPos}; right: ${tapeRightPos};
          width: 90px; height: 22px; opacity: 0.92; box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
          border-left: 1px dashed rgba(0, 0, 0, 0.15); border-right: 1px dashed rgba(0, 0, 0, 0.15);
          border-radius: 2px; z-index: 10; background: color-mix(in oklab, ${q._tapeColor} 60%, white);
          transform: rotate(${tapeRotation});
        "></span>
      `;

      if (q._isWide) {
        tapeHTML = `
          <span aria-hidden="true" style="
            pointer-events: none; position: absolute; top: -11px; left: 24px; width: 90px; height: 22px; opacity: 0.92;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08); border-left: 1px dashed rgba(0, 0, 0, 0.15); border-right: 1px dashed rgba(0, 0, 0, 0.15);
            border-radius: 2px; z-index: 10; background: color-mix(in oklab, ${q._tapeColor} 60%, white); transform: rotate(-6deg);
          "></span>
          <span aria-hidden="true" style="
            pointer-events: none; position: absolute; top: -11px; right: 24px; width: 90px; height: 22px; opacity: 0.92;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08); border-left: 1px dashed rgba(0, 0, 0, 0.15); border-right: 1px dashed rgba(0, 0, 0, 0.15);
            border-radius: 2px; z-index: 10; background: color-mix(in oklab, ${q._tapeColor} 60%, white); transform: rotate(6deg);
          "></span>
        `;
      }

      card.innerHTML = `
        ${tapeHTML}
        <div class="qw-card-q" style="color: ${innerColor}; font-style: italic;">${question}</div>
        <div class="qw-card-meta" style="color: ${innerColor}; margin-top: 16px; font-size: 12px; font-weight: 600; letter-spacing: 0.5px;">
          — ${name}${age ? `, ${age}` : ''}
        </div>
      `;
      
      container.appendChild(card);

      setTimeout(() => {
        card.style.opacity = '1';
        card.style.transform = `rotate(${q._rotation}deg) translateY(0) scale(1)`;
        resizeGridItem(card);
      }, indexInBatch * 55);
    });
    
    currentIndex += BATCH_SIZE;

    const oldTarget = document.getElementById('qw-scroll-target');
    if (oldTarget) oldTarget.remove();

    if (currentIndex < filteredQuestions.length) {
      const scrollTarget = document.createElement('div');
      scrollTarget.id = 'qw-scroll-target';
      scrollTarget.style.height = '1px';
      scrollTarget.style.width = '100%';
      container.parentNode.appendChild(scrollTarget);
      scrollObserver.observe(scrollTarget);
    }
  }

  function applyFiltersAndSort() {
    const rawVal = searchInput ? searchInput.value : '';
    const query = rawVal.trim().toLowerCase();
    const sort = sortSelect ? sortSelect.value : 'newest';
    
    updateSearchClear();

    filteredQuestions = allQuestions.filter(q => {
      const qText = (q['Question'] || '').toLowerCase();
      const catMatch = activeCategory === 'All' || q._category === activeCategory;
      const searchMatch = !query || qText.includes(query);
      return catMatch && searchMatch;
    });

    if (sort === 'oldest') {
      filteredQuestions.reverse(); 
    }

    currentIndex = 0;
    renderBatch();
  }

  let debounceTimer;
  if (searchInput) {
    searchInput.addEventListener('input', () => {
      updateSearchClear();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        applyFiltersAndSort();
      }, 250);
    });
  }

  if (searchClear) {
    searchClear.addEventListener('click', () => {
      if (searchInput) {
        searchInput.value = '';
        updateSearchClear();
        applyFiltersAndSort();
        searchInput.focus();
      }
    });
  }

  if (sortSelect) {
    sortSelect.addEventListener('change', applyFiltersAndSort);
  }

  function resizeGridItem(item) {
    item.style.gridRowEnd = 'auto'; 
    const height = item.offsetHeight;
    const rowSpan = Math.ceil((height + 32) / 10); 
    item.style.gridRowEnd = `span ${rowSpan}`;
  }

  function resizeAllGridItems() {
    const allItems = container.querySelectorAll('.qw-card');
    allItems.forEach(item => resizeGridItem(item));
  }

  window.addEventListener('resize', () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(resizeAllGridItems, 200);
  });

  function escapeHTML(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }
});
